import React from "react";
import SearchFilter from "components/searchFilter";
import useTranslation from "utils/hooks/useTranslation";

interface IPropsSearchFilter {
  usersUpdateFilter: (...args) => void;
  usersChangeFieldValue: (...args) => void;
}

const UsersFilter = ({ usersUpdateFilter, usersChangeFieldValue }: IPropsSearchFilter) => {
  const SEARCH_PLACEHOLDER = `${useTranslation({
    id: "search_name_or_email",
  })}...`;

  return <SearchFilter placeholder={SEARCH_PLACEHOLDER} updateFilter={usersUpdateFilter} changeFieldValue={usersChangeFieldValue} numbersTypedCharacters={3} />;
};

export default UsersFilter;
